(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('handbook-merge-header', {
            parent: 'entity',
            url: '/handbook-merge-header?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeHeader.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-headers.html',
                    controller: 'HandbookMergeHeaderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeHeader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('handbook-merge-header-detail', {
            parent: 'handbook-merge-header',
            url: '/handbook-merge-header/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.handbookMergeHeader.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-detail.html',
                    controller: 'HandbookMergeHeaderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('handbookMergeHeader');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HandbookMergeHeader', function($stateParams, HandbookMergeHeader) {
                    return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'handbook-merge-header',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('handbook-merge-header-detail.edit', {
            parent: 'handbook-merge-header-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-header.new', {
            parent: 'handbook-merge-header',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startTime: null,
                                finishTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('handbook-merge-header');
                });
            }]
        })
        .state('handbook-merge-header.edit', {
            parent: 'handbook-merge-header',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-dialog.html',
                    controller: 'HandbookMergeHeaderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('handbook-merge-header.delete', {
            parent: 'handbook-merge-header',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/handbook-merge-header/handbook-merge-header-delete-dialog.html',
                    controller: 'HandbookMergeHeaderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HandbookMergeHeader', function(HandbookMergeHeader) {
                            return HandbookMergeHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('handbook-merge-header', null, { reload: 'handbook-merge-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
